import { onBeforeUnmount, onMounted } from 'vue'

export function useRootClass(className: string) {
  onMounted(() => {
    document.documentElement.classList.add(className)
    document.body.classList.add(className)
  })
  onBeforeUnmount(() => {
    document.documentElement.classList.remove(className)
    document.body.classList.remove(className)
  })
}
